import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';
class Footer extends Component {
    constructor(props) {
        super(props);
        this.guardarSolicitud = this.guardarSolicitud.bind(this);
        this.routingPrevious = this.routingPrevious.bind(this);
    }

    cancelClick() {
        $("#discardChangesModal").modal();
    }

    endRequestAdvice() {
        $("#endRequestAdvice").modal();
    }

    routingPrevious() {
        this.props.routingPrevious(this.props.request);
    }

    guardarSolicitud() {
        this.props.guardarSolicitud(this.props.request);
    }

    OpenDistribucionLimites() {
        $("#viewLimits").modal();
    }

    render() {
        let genericButton;
        let mensajeLimiteExedido = undefined;
        let disabledGuardarBorradorProp = { disabled: "disabled" };

        if (this.props.permissions.components.BotonGuardarBorrador.Locked == false) {
            delete disabledGuardarBorradorProp.disabled;
        }

        if (this.props.limiteExedido == 0) {
            if (this.props.readyRequest) {
                genericButton = <div className="col-md-4 right">
                    <GenericSimpleIconButton text="Guardado en proceso..." buttonClass="btn btn-cta disabled" iconClass="fa fa-circle-o-notch fa-spin" />
                </div>
            }
            else {
                genericButton = <div className="col-md-4">
                    <GenericSimpleButton text="Finalizar solicitud" buttonClass="btn btn-cta float-right" onClick={this.guardarSolicitud} />
                </div>
            }
        } else {
            genericButton = <div className="col-md-4">
                <div className="dropdown open float-right">
                    <button id="botonBloqueadoConfirmar" type="dropdown" className="btn btn-cta" disabled>Finalizar solicitud</button>
                    <ul className="dropdown-menu dropdown-stay-open">
                        <li>
                            <p><b>Hay inconsistencias en la distribución de límites</b></p>
                            <p>Los límites de las cuentas y de las tarjetas presentan incosistencias que debe resolver.</p>
                            <p>Por favor corríja los limites volviendo a los pasos anteriores antes de finalizar la solicitud.</p>
                        </li>
                    </ul>
                </div>
            </div>
        }

        return (<div className="row">
            {mensajeLimiteExedido}
            {this.props.permissions.components.BotonesAnteriorSiguiente.Active == true &&
                <div className="col-md-2">
                    <Link to={ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_TARJETA")}><GenericSimpleButton text="&#60; Anterior" buttonClass="btn btn-secondary" /*onClick={this.routingPrevious}*/ /></Link>
                </div>}
            <div className="col-md-4">
                <Link to={ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_VISTA_CLIENTE")}><GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" /*onClick={this.cancelClick} *//></Link>
                
            </div>
            <div className="col-md-2">
                &nbsp;
            </div>
            {genericButton}
        </div>);
    }
};

export default Footer